import { connect } from 'react-redux';
import { getThemePrimaryColor, getThemeVariant } from '../../modules/configuration/selectors';
import { ApplicationState } from '../../types';
import { ThemeWrapper, ThemeWrapperProps } from './ThemeWrapper';

type StateProps = Pick<ThemeWrapperProps, 'primaryColor' | 'variant'>;
type OwnProps = Omit<ThemeWrapperProps, keyof StateProps>;

const mapStateToProps = (state: ApplicationState): StateProps => ({
    primaryColor: getThemePrimaryColor(state),
    variant: getThemeVariant(state),
});

export const ThemeProvider = connect<StateProps, {}, OwnProps, ApplicationState>(mapStateToProps)(ThemeWrapper);
